/**
 * Copyright IBM Corp. 2016, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import OverflowMenuItem from '../OverflowMenuItem/index.js';

var _excluded = ["children"];
var TableToolbarAction = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default.createElement(OverflowMenuItem, _extends({
    ref: ref,
    itemText: children
  }, rest));
});
TableToolbarAction.displayName = 'TableToolbarAction';
TableToolbarAction.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired
};
var TableToolbarAction$1 = TableToolbarAction;

export { TableToolbarAction$1 as default };
